import { cB as o } from "../../../_utils/cssr/index.js";
const s = o("popselect-menu", `
 box-shadow: var(--n-menu-box-shadow);
`);
export {
  s as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/popselect/src/styles/index.cssr.js
// module id = 1728
// module chunks = 67